"use es6";

import { fillOffset } from "./fill";
function defaultOffset(arr) {
  const offset = [0];
  fillOffset(offset, arr.length - 1);
  return offset;
}
export { defaultOffset };